import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { node, shape, string } from 'prop-types';

import Image from '~/components/Image';

import { getTutorialPaths } from '~/utilities/tutorials';

import style from './Tutorial.module.scss';

const Tutorial = ({ tutorial, children, className }) => {
  const { banner, key, className: tutorialClassName } = tutorial;

  const history = useHistory();

  const {
    location: { pathname },
  } = history;
  const { route, path } = getTutorialPaths(tutorial);

  const to =
    pathname !== route
      ? {
          pathname: route,
          state: { tutorialPath: path },
        }
      : path;

  return (
    <Link
      to={to}
      className={classNames(style.tutorial, tutorialClassName, className)}
    >
      <Image
        className={style.image}
        path={banner}
        alt={key}
      />
      {children}
    </Link>
  );
};

Tutorial.propTypes = {
  tutorial: shape({
    banner: string.isRequired,
    _id: string.isRequired,
    key: string.isRequired,
    placement: string.isRequired,
    className: string,
  }),
  className: string,
  children: node,
};

export default Tutorial;
